var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlagselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 19.2,
    viewBox: "0 0 15 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M185.169,165.33v19.2h2.4v-8.4h12.6v-10.8h-15Z",
    transform: "translate(-185.169 -165.33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagselect);
export default __webpack_public_path__ + "static/media/icon_flag.select.fe4cf910de69595bfb16ed8a97cb2b52.svg";
export { ForwardRef as ReactComponent };